<template>
  <el-container id="tab">
    <el-aside :width="isCollapse ? '20px' : '300px'">
      <el-card v-show="!isCollapse" class="box-card" shadow="never">
        <div slot="header">
          <span>查询条件</span>
          <el-button style="float: right; padding: 3px 0" icon="el-icon-d-arrow-left" type="text" @click="isCollapse = !isCollapse"></el-button>
        </div>
        <el-form label-width="80px" :model="queryForm" :rules="queryFormRules" ref="queryFormRef" size="small">
          <el-scrollbar>
            <el-form-item label="单号" prop="billNo.selected">
              <el-input v-model.trim="queryForm.billNo.selected" placeholder="请输入单号" clearable></el-input>
            </el-form-item>
            <el-form-item label="商品" prop="product.selected">
              <el-select class="select_multiple" ref="productSelectRef" style="width: 100%;" v-model="queryForm.product.selected" value-key="value" multiple clearable placeholder="请选择商品名称" @focus="productInputFocus" @change="productChange">
                <el-option v-for="item in queryForm.product.list" :key="item.value" :label="item.text" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="单据日期" prop="billDate.selected">
                <date-picker
                  style="width: 100%;"
                  v-model="queryForm.billDate.selected"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions">
                </date-picker>
            </el-form-item>
            <el-form-item label="客户" prop="customer.selected">
              <select-multiple class="select_multiple" style="width: 100%;" v-bind:select-data="queryForm.customer" isTable :column-list="selectMultipleTableColumnListCommon.customer"></select-multiple>
            </el-form-item>
            <el-form-item label="仓库" prop="inWarehouse.selected">
              <select-multiple class="select_multiple" style="width: 100%;" v-bind:select-data="queryForm.inWarehouse"></select-multiple>
            </el-form-item>
            <el-form-item label="订单来源" prop="isFromVehicle.selected">
              <el-select v-model="queryForm.isFromVehicle.selected" placeholder="请选择订单来源" clearable style="width: 100%;">
                <el-option label="手机" value="Y" ></el-option>
                <el-option label="电脑" value="N" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生产日期" prop="productionDate.selected">
              <el-date-picker
                style="width: 100%;"
                v-model="queryForm.productionDate.selected"
                type="date"
                placeholder="选择生产日期"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">查询</el-button>
              <el-button @click="onReset">重置</el-button>
            </el-form-item>
          </el-scrollbar>
        </el-form>
      </el-card>
      <div class="is-collapse" v-show="isCollapse" @click="isCollapse = !isCollapse">
        <span style="text-align: center;">查询</span>
        <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
        <span style="text-align: center;">条件</span>
      </div>
    </el-aside>
    <el-main>
      <div class="el-tabs el-tabs--top el-tabs--border-card">
        <div class="el-tabs__header is-top">
          <div class="el-tabs__nav-wrap is-top">
            <div class="el-tabs__nav-scroll">
              <div class="el-tabs__nav is-top">
                <div class="el-tabs__item is-top is-active">订单占用查询</div>
              </div>
            </div>
          </div>
        </div>
        <div class="el-tabs__content">
          <el-card shadow="never" v-if="false">
            <el-form :inline="true" size="small">
              <el-form-item>
                <!-- <el-button type="primary" @click="toJump">订单管理</el-button> -->
              </el-form-item>
            </el-form>
          </el-card>
          <div class="table" v-loading="tableLoading">
            <el-table ref="table" :data="tableData" style="width: 100%" border stripe height="100%" max-height="100%" reserve-selection :row-key="getRowKey">
              <!-- <el-table-column type="selection" width="55" align="center"></el-table-column> -->
              <el-table-column prop="customerName" label="门店" width="180" align="center"></el-table-column>
              <el-table-column prop="itemName" label="商品" width="180" align="center"></el-table-column>
              <el-table-column prop="billQtyFormat" label="数量" width="100" align="center"></el-table-column>
              <el-table-column prop="totalAmt" label="商品总价" width="100" align="center"></el-table-column>
              <el-table-column prop="billNo" label="单号" width="180" align="center"></el-table-column>
              <el-table-column prop="entryDateTime" label="制单时间" width="180" align="center"></el-table-column>
              <el-table-column prop="isFromVehicle" label="订单来源" width="100" align="center"></el-table-column>
              <el-table-column prop="remark" label="备注" align="center"></el-table-column>
            </el-table>
          </div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[10, 20, 100]" :page-size="pagination.size" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
        </div>
      </div>
    </el-main>
    <el-dialog title="选择商品" :visible.sync="selectProductVisible" width="1080px" :close-on-click-modal="false" custom-class="product-dialog">
      <selectProduct v-if="selectProductVisible" @get-product-data="getProductData" :default-checked-keys="queryForm.product.list"></selectProduct>
    </el-dialog>
  </el-container>
</template>

<script>
import { pickerOptions } from '@/assets/js/common.js'
import selectProduct from '@/components/common/selectProduct.vue'
import datePicker from '@/components/common/datePicker.vue'
export default {
  name: "OrderOccupy",
  props: ['warehouseID', 'warehouseName', 'itemID', 'itemName'],
  components: {
    selectProduct,
    datePicker
  },
  mixins: [selectMultipleTableColumnListCommonMixins],
  data () {
    return {
      isCollapse: false,
      queryForm: {
        billNo: { submitName: 'billNo', selected: '' },
        product: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品名称', request: { url: '/Account/itemMasterDefine/selectItemMastForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: '' }},
        // billDate: { submitName: 'billDate', selected: [getAddDate(-3), getNowFormatDate()] },
        billDate: { submitName: 'billDate', selected: [] },
        customer: { submitName: 'customerID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: '' }},
        inWarehouse: { submitName: 'warehouseID', selected: '', valueIsObj: true, isMultiple: false, isAll: false, isShowAll:false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择仓库', request: { url: '/Account/wareHouseDefine/selectWarehouseForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: '' }},
        isFromVehicle: { submitName: 'isFromVehicle', selected: '' },
        productionDate: { submitName: 'productionDate', selected: '' },
      },
      selectProductVisible: false,
      pickerOptions: pickerOptions,
      tableLoading: false,
      tableData: [],
      pagination: {
        page: 1,
        size: 10,
        total: 11
      },
      queryFormRules: {
        'inWarehouse.selected': [
          { required: true, message: '请先选择仓库', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    queryItem () {
      let tempItem = {}
      Object.values(this.queryForm).forEach(item => {
        if (item.submitName == 'billDate') {
          tempItem['beginDate'] = item.selected[0] || ''
          tempItem['endDate'] = item.selected[1] || ''
        } else {
          if (Array.isArray(item.selected)) {
            tempItem[item.submitName] = item.selected.map(i => ("'" +  i.value + "'")).join(',')
          } else if (typeof item.selected == 'object') {
            tempItem[item.submitName] = item.selected.value
          } else {
            tempItem[item.submitName] = item.selected
          }
        }
      })
      return tempItem
    }
  },
  created () {
    this.getRouterQuery()
    this.getTableData()
  },
  methods: {
    getRouterQuery () {
      console.log(this.$route.query)
      let { itemName, itemID, productionDate, warehouseID, warehouseName } = this.$route.query
      if (itemID && itemName) {
        this.queryForm.product.selected = [{ value: itemID, text: itemName }]
        this.queryForm.product.list = [{ value: itemID, text: itemName }]
      }
      if (productionDate) {
        this.queryForm.productionDate.selected = productionDate
      }
      if (warehouseID && warehouseName) {
        this.queryForm.inWarehouse.selected = { value: warehouseID, text: warehouseName }
        this.queryForm.inWarehouse.list = [{ value: warehouseID, text: warehouseName }]
      }
    },
    productChange(val) {
        this.queryForm.product.list = val
    },
    productInputFocus () {
      this.$refs['productSelectRef'].blur()
      this.selectProductVisible = true
    },
    getProductData (data) {
      this.selectProductVisible = false
      this.$set(this.queryForm.product, 'list', data)
      this.$set(this.queryForm.product, 'selected', data)
    },
    getRowKey(row) {
      return row.id;
    },
    async getTableData () {
      this.tableLoading = true
      const { data: res } = await this.$http.post('/Account/InvCheckVue/selectItemOnLoadStatusByItemID.html', this.Qs.stringify({...this.queryItem, ...this.pagination}))
      this.tableLoading = false
      if (res.code != 'success') return this.$message.error(res.message)
      let { data, total } = JSON.parse(res.result)
      this.tableData = JSON.parse(data)
      this.pagination.total = total
    },
    onSubmit () {
      this.$refs['queryFormRef'].validate((valid) => {
        if (!valid) {
          return this.$confirm('请先选择仓库', '提示', {
            confirmButtonText: '确定',
            showCancelButton: false,
            type: 'warning'
          })
        }
      this.getTableData()
      });
    },
    onReset () {
      this.$refs['queryFormRef'].resetFields()
      this.pagination.page = 1
      this.getRouterQuery()
    },
    toJump () {
      let billNo = this.$refs.table.selection.map(i => ("'" + i.billNo + "'")).join(',') || ''
      if (billNo == '') return this.$message.warning('请至少选择一个单据')
      let width = top.document.browser.availiframeWidth.value
      let height = top.document.browser.availiframeHeight.value
      top.addPanel('订单管理', `/Account/sys/presellProcess/orderManagement.html?billNo=${ billNo }`, width, height, true)
    },
    handleSizeChange (newSize) {
      this.pagination.size = newSize
      this.getTableData(true)
    },
    handleCurrentChange (newPage) {
      this.pagination.page = newPage
      this.getTableData(true)
    },
  }
}
</script>

<style scoped lang="less">
#tab {
  // height: calc(100vh - 20px);
  .el-aside {
    .box-card {
      height: calc(100% - 2px);
      ::v-deep .el-card__header {
        padding: 8px 20px;
      }
      ::v-deep .el-card__body {
        padding: 6px;
        height: calc(100% - 37px);
      }
    }
    .is-collapse {
      width: calc(100% - 2px);
      height: calc(100% - 2px);
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      border: 1px #DCDFE6 solid;
      cursor: pointer;
      background-color: rgba(83, 168, 255, 0.1);
      color: #409EFF;
    }
    .select_multiple {
      ::v-deep .el-select__tags {
        max-height: 80px;
        overflow-y: auto;
      }
    }
  }
  .el-main {
    padding: 0 0 0 12px;
    .el-tabs {
      height: 100%;
      box-sizing: border-box;
      .el-tabs__header {
        .el-tabs__item {
          height: 33px;
          line-height: 33px;
        }
      }
      .el-tabs__content {
        padding: 10px 15px;
        height: calc(100% - 32px);
        box-sizing: border-box;
        ::v-deep .el-card {
          .el-card__body {
            padding: 12px;
            .el-form {
              .el-form-item {
                margin: 0;
              }
            }
          }
        }
      }
    }
    .table {
      // height: calc(100% - 60px - 32px);
      height: calc(100% - 32px);
      box-sizing: border-box;
      ::v-deep .el-table {
        th, td {
          padding: 6px 0;
        }
      }
    }
  }
}
</style>